@import '../../styles/palette.scss';

.duplicateContent {
  a {
    color: _palette(text);

    &:hover {
      text-decoration: none;
    }
  }
}
